<template>
	<div v-if="!isMobile" class="sf-wrapper hide-mobile">
		<h1 class="visually-hidden">Store Finder</h1>
		<div class="sf-left">
			<store-search />
			<store-list v-if="stores" :stores="stores" />
		</div>
		<div class="sf-right">
			<map-with-markers v-if="!isCrawler" />
		</div>
	</div>
	<div v-else class="sf-wrapper">
		<h1 class="visually-hidden">Store Finder</h1>
		<store-search />
		<div class="map-mobile">
			<map-with-markers v-if="!isCrawler" />
		</div>
		<store-list v-if="stores" :stores="stores" />
	</div>
</template>

<script>
import MapWithMarkers from './MapWithMarkers.vue';
import StoreList from './StoreList.vue';
import StoreSearch from './StoreSearch.vue';
import { get } from 'vuex-pathify';
export default {
	name: 'StoreFinderApp',
	components: {
		StoreList,
		StoreSearch,
		MapWithMarkers
	},
	computed: {
		stores: get('stores'),
		localStore: get('localStore'),
		isCrawler: get('isCrawler'),
		isMobile() {
			return this.$mq === 'mobile';
		}
	},
};
</script>

<style lang='less'>
@import '../../../less/_mixins.less';
.sf-wrapper {
	display: flex;
	.sf-left {
		max-width: 380px;
		flex: 1 1 380px;
	}
	.sf-right {
		margin-left: 17px;
		position: relative;
		flex: 2 2 370px;
	}
	body, h1, h2, h3, h4, h5, h6 {
		font-family: Roboto!important;
	}
}
@media screen and (max-width: @mobile) {
	#content {
		padding: 0!important;
	}
	.sf-wrapper {
		flex-direction: column;
	}
}
</style>